import React from 'react';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import CloudDoneIcon from 'housecall-ui/dist/IconsAndImages/Icons/CloudDone';
import InputAdornment from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/InputAdornment';
import Tooltip from 'housecall-ui/dist/DesignSystem/DataDisplay/Tooltips/Tooltip';
import GoogleGLogo from 'housecall-ui/dist/IconsAndImages/Icons/Google';
import { GOOGLE_ICON } from '../../DataEnrichment/DataEnrichmentOrgData';

const styles = {
  color: {
    color: '#00c853',
  },
  size: {
    fontSize: '20px !important',
  },
};

const DataEnrichmentIcon = (props) => {
  const title =
    props.show === GOOGLE_ICON
      ? 'Prefilled with your Google business information'
      : 'Prefilled with your public information';
  return (
    <InputAdornment
      position="end"
      style={{ display: props.show ? null : 'none' }}
    >
      <Tooltip
        title={title}
        placement="top"
      >
        {props.show === GOOGLE_ICON ? (
          <GoogleGLogo className={props.classes.size} />
        ) : (
          <CloudDoneIcon className={props.classes.color} />
        )}
      </Tooltip>
    </InputAdornment>
  );
};

export default withStyles(styles)(DataEnrichmentIcon);
